module.exports = __webpack_public_path__ + "img/6.04c6bcd3.svg";